import { Component, Input } from '@angular/core';
import { Ranking } from '@app/shared/models/ranking.model';
import { RankingItemComponent } from '../ranking-item/ranking-item.component';

@Component({
  selector: 'slotcom-ranking-list',
  templateUrl: './ranking-list.component.html',
  standalone: true,
  imports: [RankingItemComponent],
})
export class RankingListComponent {
  @Input() rankings: Ranking[];
  @Input() isFriends: boolean;
  @Input() showMedals?: boolean = true;
  @Input() hideReward?: boolean = false;
}
